import { Attribute, ChangeDetectorRef, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { getFormErrorMessage } from '@app/core/utils/form-error-message.util';

@Component({
  standalone: true,
  selector: 'ups-date',
  templateUrl: './form-date.component.html',
  styleUrls: ['./form-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'form-group input-underline'
  },
  imports: [
    DatePipe,
    IonicModule,
    TranslocoModule
  ],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormDateComponent
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: FormDateComponent
    }
  ]
})
export class FormDateComponent implements ControlValueAccessor, Validator {

  @Input() public label?: string;
  @Input() public placeholder!: string;
  @Input() public required: boolean = false;
  @Input() public disabled: boolean = false;
  public isTouched: boolean = false;
  public value: string = '';
  public errorMsg!: string;
  protected formControl!: AbstractControl;
  protected onChange: (_val: any) => void = (_val: any) => {};
  protected onTouched: () => void = () => {};

  constructor(
    @Attribute('id') public id: string,
    protected readonly ch: ChangeDetectorRef
  ) { }

  public registerOnChange(fn: any): void{ this.onChange = fn; }

  public registerOnTouched(fn: any): void{ this.onTouched = fn; }

  public writeValue(val: any): void{ 
    this.value = val; 
    this.ch.markForCheck();
  }

  public setDisabledState?(d: boolean): void{ 
    this.disabled = d; 
    this.ch.markForCheck();
  }

  public validate(control: AbstractControl): ValidationErrors | null{
    this.formControl = control;
    return null;
  }

  public changeDate({ detail: { value }}: any): void{
    if (!this.isTouched) {
      this.onTouched();
      this.isTouched = true;
    }

    if (!this.disabled) {
      this.value = value;
      this.ch.markForCheck();

      this.onChange(this.value);
      this.errorMsg = getFormErrorMessage(this.formControl.errors, this.label);
    }
  }
}
